/// <reference path="../_references.js" />

function CacheSettings() {
    "use strict";

    // System
    this.OrganizationsUpdateInterval = 60 * 10; // 10 mins
    this.UserPreferenceUpdateInterval = 60 * 10; // 10 mins
    this.SystemMessageUpdateInterval = 60 * 5; // 5 mins


    // Dashboard
    this.DashboardReportUpdateInterval = 60 * 60; // 60 mins
    this.DashboardReportColumnsUpdateInterval = 60 * 20; // 20 mins
    this.EnrolleeReportUpdateInterval = 60; // 1 min
    this.EnrolleeReportColumnUpdateInterval = 60 * 60 * 2; //120 mins
    this.FullEnrolleeReportUpdateInterval = 60; // 1 min
    this.EnrolleeTileUpdateInterval = 60 * 2; // 2 mins
    this.EventTileUpdateInterval = 30; // 30 sec
    this.ZoneTileUpdateInterval = 60 * 30; // 30 mins
    this.AnalysisTileUpdateInterval = 60 * 3; // 3 mins
    this.ReportTileUpdateInterval = 60; // 1 min
    this.InventoryTileUpdateInterval = 60 * 10; // 10 mins 
    this.AgentTileUpdateInterval = 60 * 10; // 10 mins
    this.UserTileUpdateInterval = 60 * 10; // 10 mins


    // Enrollees
    this.EnrolleesUpdateInterval = 60; // 1 min
    this.CurrentDeviceAssignmentsUpdateInterval = 60 * 10; // 10 min
    this.EnrolleeEventSummaryUpdateInterval = 60; // 1 min
    this.OffenderSchedulesUpdateInterval = 60 * 10; // 10 min
    this.EnrolleeLastContactUpdateInterval = 30; // 30 sec
    this.TagUpdateInterval = 60 * 10; // 10 min
    this.EidReservationUpdateInterval = 60 * 2; // 2 min

    //RiskLevels
    this.RiskLevelUpdateInterval = 60 * 5; // 5 min
    // Events
    this.EventsUpdateInterval = 30; // 30 sec


    // Zones
    this.ZonesUpdateInterval = 60 * 10; // 10 min


    // Analysis
    this.IncidentsUpdateInterval = 60; // 1 min


    // Reports
    this.ReportUpdateInterval = 60; // 1 min
    this.ReportInstanceUpdateInterval = 60; // 1 min
    this.ReportFilterUpdateInterval = 60; // 1 min
    this.ReportFilterInstanceUpdateInterval = 60; // 1 min
    this.ReportGroupReportUpdateInterval = 60; // 1 min
    this.ReportAgentUpdateInterval = 60; // 1min


    // Inventory
    this.DevicesUpdateInterval = 60; // 1 min
    this.DevicesContactUpdateInterval = 60; // 1 min
    this.DeviceClustersUpdateInterval = 30 * 10; // 5 min
    this.DeviceClusterDevicesUpdateInterval = 60 * 10; // 10 min
    this.DeviceLastContactUpdateInterval = 30; // 30 sec


    // Agents
    this.AgentsUpdateInterval = 60 * 10; // 10 min
    this.StopAgentsUpdateInterval = 60 * 20; // 20 min
    this.UsersUpdateInterval = 60 * 10; // 10 min
    this.EscalationPlanUpdateInterval = 60 * 3; // 3 min
}

function PaginationSettings() {
    "use strict";

    this.DashboardItems = 40;
    this.DashboardEventsItems = 7;
    this.EnrolleesOffendersItems = 40;
    this.EnrolleesVictimsItems = 7;
    this.EventsItems = 7;
    this.EventsListItems = 30;
    this.ZonesItems = 7;
    this.AnalysisIncidentsItems = 7;
    this.AnalysisIncidentsMatchItems = 7;
    this.AnalysisSpatialItems = 7;
    this.ReportsItems = 7;
    this.InventoryDevicesItems = 7;
    this.InventoryDeviceClustersItems = 7;
    this.AgentsAgentsItems = 7;
    this.AgentsEscalationPlansItems = 7;
}

function SystemSettings() {
    "use strict";

    this.IsDebug = false;
    this.EventHistoryOffset = 7;
}